(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.index = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.isArray = isArray;
  _exports.isBoolean = isBoolean;
  _exports.isDateTime = isDateTime;
  _exports.isError = isError;
  _exports.isFunction = isFunction;
  _exports.isHTMLElement = isHTMLElement;
  _exports.isImage = isImage;
  _exports.isInteger = isInteger;
  _exports.isInterval = isInterval;
  _exports.isNumber = isNumber;
  _exports.isObject = isObject;
  _exports.isReactClassComponent = isReactClassComponent;
  _exports.isReactComponent = isReactComponent;
  _exports.isReactEntity = isReactEntity;
  _exports.isReactFunctionalComponent = isReactFunctionalComponent;
  _exports.isString = isString;
  function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
  /*
   |------------------------------------------------------------------------------
   | Native Javascript
   |------------------------------------------------------------------------------
   */

  /**
   * Check if parameter is a boolean
   * @param   {any} value - Value to check the type of
   * @returns {boolean} True if is
   */
  function isBoolean(value) {
    return typeof value === "boolean";
  }

  /**
   * Check if parameter is a number
   * @param   {any} value - Value to check the type of
   * @returns {boolean} True if is
   */
  function isNumber(value) {
    return typeof value === "number";
  }

  /**
   * Check if parameter is an integer
   * @param   {any} value - Value to check the type of
   * @returns {boolean} True if is
   */
  function isInteger(value) {
    return Number.isInteger(value);
  }

  /**
   * Check if parameter is a string
   * @param   {any} value - Value to check the type of
   * @returns {boolean} True if is
   */
  function isString(value) {
    return typeof value === "string";
  }

  /**
   * Check if parameter is not null and its type is `object`
   * @param   {any} value - Value to check the type of
   * @returns {boolean} True if is
   */
  function isObject(value) {
    return !!value && _typeof(value) === "object";
  }

  /**
   * Check if parameter is an array
   * @param   {any} value - Value to check the type of
   * @returns {boolean} True if is
   */
  function isArray(value) {
    return Array.isArray(value);
  }

  /**
   * Check if parameter is a function
   * @param   {any} value - Value to check the type of
   * @returns {boolean} True if is
   */
  function isFunction(value) {
    return typeof value === "function";
  }

  /**
   * Check if parameter is an instance of Error
   * @param   {any} value - Value to check the type of
   * @returns {boolean} True if is
   */
  function isError(value) {
    return value instanceof Error;
  }

  /*
   |------------------------------------------------------------------------------
   | Browser
   |------------------------------------------------------------------------------
   */

  /**
   * Check if parameter is an image
   * @param   {any} value - Value to check the type of
   * @returns {boolean} True if is
   */
  function isImage(value) {
    return typeof window !== "undefined" && value instanceof window.Image;
  }

  /**
   * Check if parameter is an HTML element
   * @param   {any} value - Value to check the type of
   * @returns {boolean} True if is
   */
  function isHTMLElement(value) {
    return typeof window !== "undefined" && value instanceof window.HTMLElement;
  }

  /*
   |------------------------------------------------------------------------------
   | Luxon
   |------------------------------------------------------------------------------
   */

  /**
   * Check if parameter is an instance of luxon's DateTime
   * @param   {any} value - Value to check the type of
   * @returns {boolean} True if is
   */
  function isDateTime(value) {
    return isObject(value) && !!value.isLuxonDateTime;
  }

  /**
   * Check if parameter is an instance of luxon's Interval
   * @param   {any} value - Value to check the type of
   * @returns {boolean} True if is
   */
  function isInterval(value) {
    return isObject(value) && !!value.isLuxonInterval;
  }

  /*
   |------------------------------------------------------------------------------
   | React
   |------------------------------------------------------------------------------
   */

  var reactFuncCompPattern = /return\s.+\.createElement\(/;

  /**
   * Check if parameter is a React class component
   * @param   {any} value - Value to check the type of
   * @returns {boolean} True if is
   */
  function isReactClassComponent(value) {
    return typeof value === "function" && !!value.prototype.isReactComponent;
  }

  /**
   * Check if parameter is a React functional component
   * @param   {any} value - Value to check the type of
   * @returns {boolean} True if is
   */
  function isReactFunctionalComponent(value) {
    return typeof value === "function" && !!String(value).match(reactFuncCompPattern);
  }

  /**
   * Check if parameter is a React (class or functional) component
   * @param   {any} value - Value to check the type of
   * @returns {boolean} True if is
   */
  function isReactComponent(value) {
    return isReactClassComponent(value) || isReactFunctionalComponent(value);
  }

  /**
   * Check if parameter is a React component or element
   * @param   {any} value - Value to check the type of
   * @returns {boolean} True if is
   */
  function isReactEntity(value) {
    return /*#__PURE__*/(0, _react.isValidElement)(value) || isReactComponent(value);
  }
});